var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOosBarGroup = function SvgOosBarGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.137 40.775c-1.094 1.093-3.246.714-4.809-.849-1.562-1.562-1.942-3.714-.848-4.808L35.118-.52c1.093-1.094 3.246-.714 4.808.848 1.563 1.563 1.942 3.715.849 4.809z"
  })));
};
export default SvgOosBarGroup;